import type { PayloadAction } from "@reduxjs/toolkit"
import { createAppSlice } from "../../app/createAppSlice"
import type { GameLogicConfig } from "@types"

// Load default from JSON
export const configInitialState: GameLogicConfig = {
  language: "en",
  variant: "regular",
}

export const configSlice = createAppSlice({
  name: "config",
  initialState: configInitialState,
  reducers: create => ({
    editConfigLanguage: create.reducer(
      (state, action: PayloadAction<string>) => {
        state.language = action.payload
      },
    ),
    setVariant: create.reducer(
      (state, action: PayloadAction<"regular" | "srh">) => {
        state.variant = action.payload
      },
    ),
  }),
  // You can define your selectors here. These selectors receive the slice
  // state as their first argument.
  selectors: {
    // State
    selectConfigLanguage: config => config.language,
    selectVariant: config => config.variant,
  },
})

// Action creators are generated for each case reducer function.
export const { editConfigLanguage, setVariant } = configSlice.actions

// Selectors regameed by `slice.selectors` take the root state as their first argument.
export const { selectConfigLanguage, selectVariant } = configSlice.selectors
